import { memo, ReactNode, useEffect } from "react";
import { updateLocalization } from "./i18n";

export interface LocalizationSettings {
  enabled?: boolean | null;
}

export const LocalizationProvider = memo(function LocalizationProvider({
  localization,
  preferredLocale,
  children,
}: {
  localization: LocalizationSettings | undefined;
  preferredLocale?: string | null;
  children: ReactNode;
}) {
  useEffect(() => {
    updateLocalization(localization?.enabled ?? false, preferredLocale);
  }, [localization?.enabled, preferredLocale]);

  return <>{children}</>;
});
